module.exports = __webpack_public_path__ + "static/media/Screenshot3.5d900944.png";